var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7879 12.8782L9.54468 15.4807L8.86287 15.4837L11.548 12.3711L11.8298 12.0444L11.5479 11.7178L8.86316 8.6077L9.54455 8.61071L11.7878 11.2154L12.1665 11.6551L12.5454 11.2155L14.7887 8.61305L15.4685 8.61004L12.7876 11.7204L12.5062 12.0469L12.7876 12.3733L15.4708 15.4861L14.791 15.483L12.5454 12.8782L12.1666 12.4389L11.7879 12.8782ZM12.1667 1C5.94402 1 0.875 5.91259 0.875 12C0.875 18.0874 5.94402 23 12.1667 23C18.3893 23 23.4583 18.0874 23.4583 12C23.4583 5.91259 18.3893 1 12.1667 1Z",
    fill: "#1677FF",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePhoto);
export default __webpack_public_path__ + "static/media/remove-photo.15533e5d66b20fbfa6aec253b64ac4da.svg";
export { ForwardRef as ReactComponent };